export interface IAutomationsReturnLocationState {
	/**
	 * Query string of the automations list the user opened the canvas from. The list keeps its filters in the URL, so
	 * carrying the search here is what lets publishing return the user to the same filters instead of an unfiltered list.
	 */
	automationsSearch?: string;
}

interface IAutomationsReturnLocation {
	pathname: string;
	search: string;
}

export function resolveAutomationsReturnLocation(
	state: IAutomationsReturnLocationState | undefined,
	pathname = '/automations'
): IAutomationsReturnLocation {
	const search = state?.automationsSearch ?? '';

	return {
		pathname,
		search: search === '?' ? '' : search,
	};
}
